"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = function (str) {
    if (typeof str === "string" && str.length > 0) {
        return str[0].toLocaleUpperCase() + str.slice(1);
    }
    return str;
};
